export function CamelCase(str) {
  if (typeof str !== 'string') {
    return str;
  }
  if (str.substring(0, 1) != '_' && str.length > 0) {
    str = '_' + str;
  }
  return str
    .replace(/_(.)/g, function (match, group1) {
      return ' ' + group1.toUpperCase();
    })
    .trim();
}
